<template>
  <div class="payments">
    <div>
      <div class="header"></div>
      <div class="section">
        <div class="container">
          <div>
            <h2>有料プラン申込</h2>
            <div class="main-area">
              <div>
                1契約&nbsp;年額<span class="price-large">5,000</span
                >円（税込<span class="price-normal">5,500</span>円）
              </div>
            </div>
            <div class="sub-area">
              <div class="agree-area">
                <dl class="columns">
                  <input id="box1" type="checkbox" v-model="agreement1"/>
                  <label for="box1"><a
                      href="https://www.ricelog.com/service.html"
                      target="_blank"
                      rel="noopener"
                    >
                      利用規約
                    </a>
                    に同意する。</label>
                </dl>
                <dl class="columns">
                  <input
                    id="box2"
                    type="checkbox"
                    v-model="agreement2"
                  />
                  <label for="box2"><a
                      href="https://www.sglabs.jp/privacy-policy/"
                      target="_blank"
                      rel="noopener"
                    >
                      プライバシーポリシー
                    </a>
                    および
                    <a
                      href="https://www.ricelog.com/privacy.html"
                      target="_blank"
                      rel="noopener"
                    >
                      個人情報の取扱いについて
                    </a>
                    に同意する。</label>
                </dl>
                <dl class="columns">
                  <span style="margin-top: 1rem; text-align: center;">
                  お支払い方法、お支払時期、解約については<a
                    href="https://www.ricelog.com/sct.html"
                    target="_blank"
                    >こちら</a
                  >をご確認ください。
                  </span>
                </dl>
              </div>
            </div>
            <div
              id="message-area"
              class="error-message mdi mdi-alert-circle-outline"
              v-if="errorMessage"
            >
              {{ errorMessage }}
            </div>
            <div
              id="message-area"
              class="information-message mdi mdi-check-circle-outline"
              v-if="message"
            >
              {{ message }}
            </div>
            <div class="card-area " :class="{ 
              complete: cardInput, 
              'ex-card-area-disable': !(agreement1 && agreement2) 
              }">
              <div ref="payjpArea"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Loader from "@/mixins/loader";
import { PAYMENT } from "@/constants/constants";

export default {
  data() {
    return {
      cardInput: false,
      errorMessage: null,
      message: null,
      agreement1 : false,
      agreement2 : false,
    };
  },

  mixins: [Loader],
  components: {},
  created() {},
  mounted() {
    this.$emit("hideMap");
    this.cardInput = false;
    this.appendPayJpScriptTag();
    window.onTokenCreated = this.onTokenCreated;
    window.onTokenFailed = this.onTokenFailed;
  },

  beforeDestroy() {
    this.destoryPayjp();
  },

  methods: {
    ...mapActions(["createSubscription", "showAccount", "showAccountID"]),
    ...mapGetters(["getAccountID"]),

    appendPayJpScriptTag() {
      const attrs = {
        "data-payjp-key": PAYMENT.KEY,
        id: "payjp-script",
        src: "https://checkout.pay.jp/",
        class: "payjp-button",
        "data-payjp-text": "有料プラン申込",
        "data-payjp-submit-text": "有料プラン申込",
        "data-payjp-lang": "ja",
        "data-payjp-token-name":"payjp-token",
        "data-payjp-three-d-secure":"true",
        "data-payjp-three-d-secure-workflow":"subwindow",
        "data-payjp-extra-attribute-email":"",
        "data-payjp-extra-attribute-phone":"",
        "data-payjp-extra-attribute-phone-code":"JP",
        "data-payjp-partial":"true",
        "data-payjp-on-created":"onTokenCreated",
        "data-payjp-on-failed":"onTokenFailed",
      };
      this.scriptEl = document.createElement("script");
      for (let key in attrs) {
        this.scriptEl.setAttribute(key, attrs[key]);
      }
      this.$refs.payjpArea.appendChild(this.scriptEl);
    },
    onTokenCreated() {
      this.loading(async () => {
        let token = document.getElementsByName("payjp-token")[0].value;
        this.errorMessage = null;
        this.message = null;
        this.cardInput = true;
        try {
          const ret = await this.createSubscription({ token: token });
          if (ret.status === 201) {
            this.message = "既に申込済みです。";
          } else {
            this.message = "申込が完了いたしました。";
          }
        } catch (err) {
          this.errorMessage =
            "申込ができませんでした。再度申込を行なってください。";
          return;
        }

        // 更新後のアカウント情報
        await this.showAccount(await this.showAccountID());
      });
    },
    onTokenFailed(res) {  // eslint-disable-line no-unused-vars
      // 処理
      this.message = null;
      this.errorMessage =
        "カード情報の読み込みに失敗しました。再度申込を行なってください。";
    },

    onAddSubscription() {},

    destoryPayjp() {
      const payjpCheckoutIframeEl = document.getElementById(
        "payjp-checkout-iframe"
      );
      payjpCheckoutIframeEl.parentElement.remove();
      this.$refs.payjpArea.removeChild(this.scriptEl);
      window.PayjpCheckout = null;
      window.onTokenCreated = null;
      window.onTokenFailed = null;
    },
  },
};
</script>

<style lang="scss">
.payments {
  height: 100vh;

  .header {
    padding-top: 2rem;
  }
  .section {
    overflow: auto;
    width: 70%;
    height: calc(100% - 130px);
    position: relative;
    margin: auto;

    .container {
      margin: 2rem;

      h2 {
        text-align: center;
        font-weight: 400;
      }

      .main-area {
        text-align: center;
        font-size: 1.5rem;

        .price-large {
          font-size: 3rem;
          margin: 1rem;
        }
        .price-normal {
          font-weight: 700;
          margin: 0.5rem;
        }
      }

      .sub-area {
        margin-top: 1rem;

        .agree-area {
          margin: auto;
          width: fit-content;
        }

        ul {
          width: fit-content;
          margin: auto;
          list-style-type: none;
        }

        a {
          margin: 0.5rem;
        }
      }
      dl.columns {
        width: 100%;
        display: grid;
        grid-template-columns: auto;
        align-items: top;
        grid-gap: 0px 0px;
        margin: 0;
        padding: 0;
        font-size: 16px;
        color: #333;
      }

      .columns dt {
        display: block;
        text-align: left;
        width: 100%;
        margin: 0;
        padding: 16px;
      }

      .columns dd {
        display: block;
        width: 100%;
        border-left: solid 1px #ddd;
        margin: 0;
        padding: 16px;

        &.input-with-unit {
          display: flex;
          align-items: center;
          .unit {
            margin-left: 1rem;
            word-break: keep-all;
          }
        }
      }
      .columns dt:nth-of-type(odd) {
        background: #f3f3f3;
      }
      .columns dd:nth-of-type(odd) {
        background: #f3f3f3;
      }

      input[type="checkbox"] {
        display: none;
      }
      input[type="checkbox"] + label {
        padding: 0 20px 0 0;
      }

      input[type="checkbox"] + label:before {
        display: inline-block;
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_checkbox_off.svg") no-repeat center
          left;
        background-size: 24px 24px;
        padding: 0 16px 0 0;
      }
      input[type="checkbox"]:checked + label:before {
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_checkbox_on.svg") no-repeat center
          left;
        background-size: 24px 24px;
        display: inline-block;
      }
    }
  }
  .card-area {
    text-align: center;
    margin: 2rem;
  }
  .card-area.complete {
    display: none;
  }
  #payjp_checkout_box input[type="button"] {
    font-size: 16px;
  }
  #message-area {
    margin: 2rem;
  }

  #button-area {
    display: flex;
    justify-content: flex-start;
    width: 100%;

    .right-box {
      right: 0;
      bottom: 0;
      width: 70px;
    }
    .center-box {
      display: inline;
      text-align: center;
      width: calc(100% - 140px);
    }
    .left-box {
      left: 0;
      bottom: 0;
      width: 70px;
    }

    .btn {
      display: inline-block;
      background: white;
      font-size: 14px;
      text-align: center;
      width: 130px;
      height: 30px;
      border-radius: 15px;
      color: var(--purple);
      padding: 6px 20px;
      margin: 10px auto 10px;
      cursor: pointer;
      &.disable {
        opacity: 0.5;
        cursor: inherit;
        pointer-events: none;
      }
      &.btn-submit {
        background: var(--purple);
        color: #fff;
        margin-left: 3px;
        margin-right: 3px;
      }
      &.btn-cancel {
        background: var(--purple-tertiary);
        color: #000;
        margin-left: 3px;
        margin-right: 3px;
      }
    }

    .text {
      right: 0;
      bottom: 0;
      display: block;
      font-size: 14px;
      padding: 3px 0px;
      margin: 10px 0;
      text-align: center;
      color: var(--purple);
      border-bottom: solid 4px transparent;
      opacity: 0.5;
      pointer-events: none;
    }
    .text.active {
      border-bottom: solid 4px var(--purple-secondary);
      opacity: 1;
      cursor: pointer;
      pointer-events: inherit;
    }
    .text.disabled {
      border-bottom: solid 4px var(--purple-secondary);
      opacity: 0.5;
      cursor: inherit;
      pointer-events: none;
    }
    .text::before {
      white-space: pre;
      content: "    ";
      background: url("~@/assets/icons/ic_delete.svg") no-repeat center left;
      background-size: 20px 20px;
      padding: 0 0 0 5px;
    }
  }

  .ex-card-area-disable {
    opacity: 0.5;
    pointer-events: none;
    cursor: none;
  }
}
</style>
